import { utxo } from '../utxo.js';
import { mempoolMethods } from './methods.js';
export const mempool = (config) => utxo(config?.baseUrl || 'https://mempool.space/api', {
    name: 'Mempool.space API',
    key: 'mempool',
    methods: {
        include: Object.keys(mempoolMethods),
    },
    ...config,
});
//# sourceMappingURL=mempool.js.map